module.exports = __webpack_public_path__ + "static/cabinet-113cae8caade2d73acd5b5558f483ab4.jpg";